export const enum WorkspaceSecondaryMenuItems {
  TASKS = 'tasks',
  PROJECTS = 'projects',
  MESSAGES = 'messages'
}
